import { HTMLAttributes } from 'react';
import { Typography, Stack } from '@legacy/components/mui-components';

interface MultiLineTranslationProps extends HTMLAttributes<HTMLElement> {
  translatedContent: string;
  paragraphComponent?: React.ElementType;
}

export const MultiLineTranslation = ({
  translatedContent,
  paragraphComponent = 'p',
  ...props
}: MultiLineTranslationProps) => {
  const textToArray = translatedContent.split(/\r?\n/);

  return (
    <Stack gap={2} {...props} component={'span'}>
      {textToArray.map((text, i) => (
        <Typography
          data-automation-id={`MultiLineTranslationParagraph${i}`}
          // eslint-disable-next-line react/no-array-index-key
          key={`${text.replaceAll(' ', '').slice(0, 10)}${i}`}
          component={paragraphComponent}
        >
          {text}
        </Typography>
      ))}
    </Stack>
  );
};
